import React from 'react';
import { Link } from 'react-router-dom';

const TeacherCard = ({ teacher }) => {
  const BASE_API = process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '');

  return (
    <Link
      to={`/giao-vien/${teacher.id}`}
      className="block bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 cursor-pointer"
    >
      {/* Teacher Image */}
      <div className="relative">
        <div className="w-full h-64 bg-orange-500 flex items-center justify-center overflow-hidden">
          {teacher.image_url ? (
            <img
              src={`${BASE_API}/${(teacher.image_url || 'uploads/images/default.jpg').replace(/^\/+/, '')}`}
              alt={teacher.full_name}
              className="w-full h-full object-cover"
            />

          ) : (
            <div className="w-32 h-32 rounded-full bg-white border-4 border-white flex items-center justify-center text-2xl font-bold text-orange-500">
              {teacher.full_name ? teacher.full_name.split(' ').map(n => n[0]).join('').slice(0, 2) : ''}
            </div>
          )}
        </div>

        {/* Subject Badge */}
        <div className="absolute bottom-4 left-4">
          <span className="bg-primary-600 text-white px-4 py-2 rounded-full text-sm font-medium">
            {teacher.major}
          </span>
        </div>
      </div>

      {/* Teacher Info */}
      <div className="p-6">
        <div className="text-center mb-4">
          <span className="text-gray-500 text-sm">— {teacher.degree} —</span>
        </div>

        <h3 className="text-xl font-bold text-gray-900 text-center mb-3">
          {teacher.full_name}
        </h3>

        <div className="flex items-center justify-center mb-3">
          <svg className="w-5 h-5 text-yellow-400 mr-1" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
          </svg>
          <span className="text-sm text-gray-600">SĐT: {teacher.phone_number}</span>
        </div>

        <p className="text-gray-600 text-sm text-center leading-relaxed">
          {teacher.school}
        </p>
      </div>
    </Link>
  );
};

export default TeacherCard;
